"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n\n  padding: 0.52em 0.375em;\n  margin: 0 0.15em;\n  border-radius: 0.75em;\n\n  font-weight: normal;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  color: #fff;\n\n  background-color: ", ";\n\n  cursor: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 0.75em 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var defaultDesign = scenario_state_1.INITIAL_SCENARIO_DESIGN.textScenarioNode;
exports.ButtonBoxDiv = styled_components_1.default.div(_templateObject());
exports.StyledParagraph = styled_components_1.default.p(_templateObject2(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor ? backgroundColor : defaultDesign.initButtonColor;
}, function (_ref2) {
  var clickable = _ref2.clickable;
  return clickable && 'pointer';
});